import api from '~/services/api';

export function insertFaleConoscoService(data) {
  return api.post('/faleconosco', data);
}